<template>
  <div class="teaching-score-input-handle-batch-commit">
    <template v-if="checking">
      <PrepareLayout prepare-url="/workspace/manager/teaching/score/input/batchStatus"
                     @prepared="onPrepared">
        <template #default="{result}">
          <div class="body">
            <AppScrollbar style="height: 100%">
              <div v-if="result"
                   :class="['result', {'has-err': result.errors && result.errors.length}]">
                <div v-if="result.successCount"
                     class="msg theme-text">提示：成功提交{{result.successCount}}行课程成绩</div>
                <div v-if="result.errors && result.errors.length"
                     class="err">
                  <DataGrid size="mini"
                            resizable
                            :data="result.errors">
                    <DataGridColumn title="序号"
                                    field="order"
                                    width="80"
                                    align="center"></DataGridColumn>
                    <DataGridColumn title="错误"
                                    field="msg"></DataGridColumn>
                  </DataGrid>
                </div>
              </div>
            </AppScrollbar>
          </div>
          <div class="footer">
            <el-button size="mini"
                       type="default"
                       @click="handleClose">关闭窗口</el-button>
          </div>
        </template>
      </PrepareLayout>
    </template>
    <template v-else>
      <div class="body"
           v-loading="committing"
           element-loading-text="数据提交中，请稍等...">
        <div class="confirm">确定要将选择的成绩进行批量提交？</div>
      </div>
      <div class="footer">
        <el-button size="mini"
                   type="primary"
                   :disabled="committing"
                   @click="handleCommit">提交保存</el-button>
        <el-button size="mini"
                   type="default"
                   @click="handleClose">关闭窗口</el-button>
      </div>
    </template>
  </div>
</template>

<script>
import PrepareLayout from '../../../../../../../../../widgets/custom/PrepareLayout'
import AppScrollbar from '../../../../../../../../../elements/AppScrollbar'
import DataGrid from '../../../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../../../elements/DataGridColumn'
export default {
  name: 'TeachingScoreInputHandleBatchCommit',
  components: {
    PrepareLayout,
    AppScrollbar,
    DataGrid,
    DataGridColumn
  },
  props: {
    preHandleParams: {
      type: Function,
      required: true
    },
    visible: Boolean
  },
  data () {
    return {
      committing: false,
      checking: false
    }
  },
  methods: {
    handleCommit () {
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/teaching/score/input/batchCommit',
        method: 'post',
        data: this.$qs.stringify(this.preHandleParams(), {
          arrayFormat: 'repeat'
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.checking = true
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    onPrepared ({result}) {
      if (result) {
        this.$emit('reloadGridData')
      } else {
        this.$emit('hidePopoverAndRefresh')
      }
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.checking = false
      }
    }
  }
}
</script>

<style lang="scss">
  .teaching-score-input-handle-batch-commit {
    & > .body {
      padding: 25px 15px;
      & > .confirm {
        font-size: 13px;
        text-align: center;
        padding: 15px 10px;
      }
    }
    & > .footer {
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
    .prepare-layout {
      min-height: 120px;
      display: flex;
      flex-direction: column;
      & > .body {
        flex: auto;
        .result {
          max-height: 300px;
          padding: 12px;
          &.has-err {
            & > .msg {
              margin-bottom: 10px;
              font-size: 13px;
              text-align: left;
              padding: 0;
            }
          }
          & > .msg {
            text-align: center;
            padding: 15px 10px;
          }
        }
      }
      & > .footer {
        flex: none;
        height: 52px;
        background-color: #fff;
        border-top: 1px solid rgba(0,0,0,.05);
        text-align: center;
        line-height: 50px;
      }
    }
  }
</style>
